<template>
  <div class="purchase-wrap">
    <TopPanel>我购买的服务</TopPanel>
    <div class="filters">
      <div class="order-status-row">
        <span class="lblStatus">状态</span>
        <order-filter
          class="switch"
          :list="purchaseStatusList"
          @change="changeOrderSelectStatus"
        ></order-filter>
      </div>
      <div class="order-status-row">
        <span class="lblStatus">类型</span>
        <order-filter
          class="switch"
          :list="orderTimeSelectList"
          @change="changeOrderSelectTime"
        ></order-filter>
      </div>
    </div>
    <div class="panel-wrap">
      <div class="table-header-panel">
        <div>产品名称</div>
        <div>类型</div>
        <div>大咖</div>
        <div>状态</div>
        <div>开始时间</div>
        <div>结束时间</div>
      </div>
      <div class="panel-content">
        <div class="item" v-for="(item, index) in orderList" :key="index">
          <div>{{ item.productName }}</div>
          <div>{{ item.rightTypeName }}</div>
          <div>{{ item.aurhorName }}</div>
          <div>{{ item.statusName }}</div>
          <div>{{ dayjs(item.beginTime).format('YYYY-MM-DD') }}</div>
          <div>{{ dayjs(item.endTime).format('YYYY-MM-DD') }}</div>
        </div>
        <div class="more" v-show="!pageEnd" @click="loadOrders()">
          点击查看更多
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderFilter from '@/components/Mine/OrderFilter'
import TopPanel from '@/components/Mine/TopPanel'
import dayjs from 'dayjs'
import { getPurchaseList } from '@/api/mine'
export default {
  name: 'MyPurchase',
  components: { TopPanel, OrderFilter },
  data() {
    return {
      purchaseStatusList: [
        { name: '全部', index: 0, value: null },
        { name: '生效中', index: 1, value: 2 },
        { name: '已过期', index: 2, value: 3 }
      ],
      orderTimeSelectList: [
        { name: '全部', index: 0, value: null },
        { name: '锦囊', index: 1, value: 1 },
        { name: '课程', index: 2, value: 2 },
        { name: '点金', index: 3, value: 4 }
      ],
      orderStatus: null,
      orderTimeRange: null,
      orderList: [],
      viewState: '',
      pageEnd: false
    }
  },
  created() {
    this.loadOrders()
  },
  methods: {
    dayjs,
    changeOrderSelectStatus(value) {
      this.viewState = ''
      this.orderStatus = value
      this.orderList = []
      this.loadOrders()
    },
    changeOrderSelectTime(value) {
      this.viewState = ''
      this.orderTimeRange = value
      this.orderList = []
      this.loadOrders()
    },
    async loadOrders() {
      var data = {
        status: this.orderStatus,
        type: this.orderTimeRange,
        direction: this.viewState ? 2 : 0,
        pageSize: 10
      }
      const res = await getPurchaseList(data, this.viewState)
      console.log('res', res)
      if (res && res.detail.list) {
        this.viewState = res.result.viewState
        this.pageEnd = res.detail.end
        const list = res.detail.list
        list.forEach(x => {
          if (x.status === 2) {
            x.statusName = '生效中'
          }
        })
        if (res.detail.flush) {
          this.orderList = list
        } else {
          this.orderList = this.orderList.concat(list)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
  width: 100%;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
.panel-wrap {
  border: solid 1px #ebebeb;
  margin: 30px 30px 30px;
  // height: 600px;
}
.panel-content {
  .item {
    display: flex;
    text-align: center;
    height: 90px;
    font-size: 14px;
    color: #262626;
    &:nth-child(even) {
      background: #fafafa;
    }
    > div {
      width: 118px;
      padding: 0 10px;
      display: inline-block;
      margin: auto;
      line-height: 18px;
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        width: 98px;
      }
    }
  }
}
.purchase-wrap {
  width: 828px;
  // height: 1225px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}
.filters {
  width: 768px;
  height: 103px;
  display: flex;
  flex-direction: column;
}
.order-status-row {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  height: 26px;
  margin-top: 20px;
  margin-left: 30px;
  position: relative;
}
.lblStatus {
  height: 14px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #262626;
  margin-top: 6px;
}
.switch {
  left: 87px;
  position: absolute;
}
.table-header-panel {
  height: 40px;
  display: flex;
  background-color: #f0f0f0;
  line-height: 40px;
}
.table-header-panel > div {
  height: 100%;
  width: 138px;
  font-size: 14px;
  color: #858585;
  text-align: center;
  &:nth-child(2),
  &:nth-child(3),
  &:nth-child(4) {
    width: 118px;
  }
}
</style>
